import { colors } from "@dotnet/telematics-design-system";

import { RectangleLoader } from "shared/loaders/RectangleLoader";

const CompanyLevelTagLoader = () => {
    const { gray200 } = colors;

    return <RectangleLoader width={65} height={20} backgroundColor={gray200} />;
};

export default CompanyLevelTagLoader;
